import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../../Services/api.service';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { cloneDeep } from 'lodash';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../Common/Components/spinner/spinner.component';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbComponent } from '../../../Common/Components/breadcrumb/breadcrumb.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';


@Component({
  selector: 'app-content-list',
  standalone: true,
  imports: [CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, RouterModule, NzLayoutModule, NzMenuModule, NzIconModule, CommonModule, NzAvatarModule,
    NzInputModule, NzButtonModule, NzListModule, NzDropDownModule, NzModalModule, NzSpaceModule, CdkVirtualForOf, NzDrawerModule, RouterLink,
    FormsModule, SpinnerComponent, BreadcrumbComponent,NzToolTipModule],
  templateUrl: './content-list.component.html',
  styleUrl: './content-list.component.scss'
})
export class ContentListComponent {
  contentListData: any;
  originalContentListData: any;
  displayContentListData: any = [];
  dataLoaded: boolean = false;
  sortDirAsc: boolean = true;
  searchText: string = '';
  groupedHeaderList: any = [];
  pageType: any = "";
  breadcrumbs: Array<{ label: string, url: any }> = [{
    label: "Content Management",
    url: ['/content-dashboard']
  }]
  contentOptions = [
    {
      id: 1, name: "Duplicate", icon: "copy"
    },
    {
      id: 2, name: "Delete", icon: "delete"
    }
  ];
  contentStatus = [
    {
      id: 1, name: "Published", clicked: false, button: "publish-btn"
    },
    {
      id: 2, name: "Saved Drafts", clicked: false, button: "draft-btn"
    },
    {
      id: 3, name: "Expired Items", clicked: false, button: "expired-btn"
    }
  ];

  constructor(public apiService: ApiService, private route: ActivatedRoute, private modalService: NzModalService) { }

  ngOnInit(): void {
    this.pageType = this.route.snapshot.paramMap.get('id');
    this.breadcrumbs.push({
      label: this.apiService.contentPageDesc ,
      url: ""
    });
    this.dataLoaded = false;
    this.apiService.getContentListByPageType(this.pageType).subscribe(response => {
      response.sort((a: any, b: any) => a['contentShortDesc'].localeCompare(b['contentShortDesc']));
      this.originalContentListData = response;
      this.originalContentListData.map((node: any) => Object.assign(node, { hover: false }));
      this.contentListData = cloneDeep(this.originalContentListData);
      this.displayContentListData = this.groupItemsByFirstLetter(this.contentListData);
      this.dataLoaded = true;
    })
  }


  trackByFn(index: number, item: any): any {
    return item.seqNo;
  }

  trackByMenu(index: number, menu: any): any {
    return menu.id;
  }

filterContentList(searchTerm: any) {
  const search = searchTerm.toLowerCase().trim();

  // If search term is empty, reset to the original list
  if (!search) {
    this.contentListData = [...this.originalContentListData];
    this.displayContentListData = this.groupItemsByFirstLetter(this.contentListData);
    return;
  }

  this.contentListData = this.originalContentListData.filter((item: any) => {
    const matchContentShortDesc = item['contentShortDesc']?.toLowerCase().includes(search);

    const matchEdpAr = item['listOfAssociatedEdpAr']?.some((edp: string) => 
      edp.toLowerCase().includes(search)
    );

    let matchPrg = false;
    if (item['listOfAssociatedPrg']) {
      matchPrg = Object.entries(item['listOfAssociatedPrg']).some(([key, value]) => {
        const keyMatch = key.toLowerCase().includes(search);
        
        let valueMatch = false;
        if (Array.isArray(value)) {
          valueMatch = value.some((val: string) => val.toLowerCase().includes(search));
        } else if (typeof value === 'string') {
          valueMatch = value.toLowerCase().includes(search);
        }

        return keyMatch || valueMatch;
      });
    }

    return matchContentShortDesc || matchEdpAr || matchPrg;
  });

  this.displayContentListData = this.groupItemsByFirstLetter(this.contentListData);
}

  sortContentList() {
    this.sortDirAsc = !this.sortDirAsc;
    if (this.sortDirAsc) {
      this.contentListData.sort((a: any, b: any) => a['contentShortDesc'].localeCompare(b['contentShortDesc']));
    } else {
      this.contentListData.sort((a: any, b: any) => b['contentShortDesc'].localeCompare(a['contentShortDesc']));
    }
    this.displayContentListData = { ...this.groupItemsByFirstLetter(this.contentListData) };
  }

  groupItemsByFirstLetter(data: any) {
    let result = data.reduce((acc: any, item: any) => {
      const firstLetter = item['contentShortDesc'] ? item['contentShortDesc'][0].toUpperCase() : [];
      acc[firstLetter] = acc[firstLetter] || [];
      acc[firstLetter].push(item);
      return acc;
    }, {});

    if (this.sortDirAsc) {
      this.groupedHeaderList = Object.keys(result).sort();
    } else {
      this.groupedHeaderList = Object.keys(result).sort().reverse();
    }
    return result;
  }

  redirect(category: any) {
    this.apiService.selectedContent = category?.contentShortDesc;
  }

  showDelete(category: any): void {
    this.modalService.confirm({
      nzTitle: `Are you sure to delete the content <b>${category.contentShortDesc}</b> ?`,
      nzContent: '',
      nzOkText: 'Delete',
      nzCancelText: 'Cancel',
      nzIconType: 'exclamation-circle',
      nzWidth:'550px',
      nzOnOk: () => this.deleteContent(category['seqNo']),
      nzCentered : true
    });
  }

  deleteContent(seqNo: string) {
    this.apiService.deleteContentById(this.pageType, seqNo).subscribe(response => {
      this.apiService.createNotification('success', 'Content deleted successfully');
      this.ngOnInit();
    },
      err => {
        this.apiService.createNotification('error', err?.error?.message);
      })
  }
}
